import React from 'react';
import { useDragLayer } from 'react-dnd';

interface Props {
  renderItem: React.ReactNode;
  type?: string;
  chosenItemId?: string;
  styles?: {
    [key: string]: string | number;
  };
}

const ItemPreview = ({ renderItem, type, chosenItemId, styles }: Props) => {
  const { clientOffset, isDragging, item } = useDragLayer((monitor) => ({
    clientOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging || item.type !== type || item?.chequeId !== chosenItemId) {
    return null;
  }

  return (
    <div
      style={{
        zIndex: 10,
        position: 'fixed',
        pointerEvents: 'none',
        top: 0,
        left: 0,
        transform: `translate3D(${clientOffset?.x ?? 0}px, ${clientOffset?.y ?? 0}px, 0)`,
        opacity: 0.5,
        ...styles,
      }}>
      {renderItem}
    </div>
  );
};

export default ItemPreview;
